import type React from 'react';
import type { MatrixItem, MatrixKleur } from '../../services/agendaService';

/**
 * De BeLagom 8-tier kleurenmatrix van het Agenda Matrix Center, plus de
 * gearceerde reistijd. Eén bron voor het grid, de maandweergave, de pop-up
 * en de legenda.
 */
export const KLEUR_KLASSE: Record<MatrixKleur, string> = {
  mint: 'bg-emerald-50 border-emerald-400 text-emerald-900',
  blauw: 'bg-navy-100 border-navy-600 text-navy-900',
  goud: 'bg-gold-100 border-gold-500 text-gold-900',
  violet: 'bg-violet-200 border-violet-700 text-violet-950',
  terracotta: 'bg-orange-100 border-orange-600 text-orange-900',
  mos: 'bg-lime-100 border-lime-700 text-lime-900',
  zand: 'bg-stone-200 border-stone-400 text-stone-700',
  paars: 'bg-purple-50 border-purple-300 text-purple-800',
  reistijd: 'bg-gray-100 border-gray-300 text-gray-500',
};

/** Vlakje in de legenda en de pop-up. */
export const KLEUR_STAAL: Record<MatrixKleur, string> = {
  mint: 'bg-emerald-200 border-emerald-500',
  blauw: 'bg-navy-600 border-navy-800',
  goud: 'bg-gold-400 border-gold-600',
  violet: 'bg-violet-700 border-violet-900',
  terracotta: 'bg-orange-500 border-orange-700',
  mos: 'bg-lime-700 border-lime-900',
  zand: 'bg-stone-300 border-stone-500',
  paars: 'bg-purple-200 border-purple-400',
  reistijd: 'bg-gray-200 border-gray-400',
};

const STREEP = 'repeating-linear-gradient(135deg, rgba(255,255,255,0.8) 0 5px, transparent 5px 10px)';
const ARCERING = 'repeating-linear-gradient(45deg, rgba(107,114,128,0.18) 0 4px, transparent 4px 8px)';

/** Gestreept = wacht op bevestiging; reistijd is altijd gearceerd. */
export function blokStijl(item: Pick<MatrixItem, 'kleur' | 'wacht_op_bevestiging'>): React.CSSProperties | undefined {
  if (item.kleur === 'reistijd') return { backgroundImage: ARCERING };
  if (item.wacht_op_bevestiging) return { backgroundImage: STREEP, borderStyle: 'dashed' };
  return undefined;
}

export interface LegendaRegel {
  kleur: MatrixKleur;
  labelKey: string;
  label: string;
}

export const LEGENDA: LegendaRegel[] = [
  { kleur: 'mint', labelKey: 'matrix.kleur.mint', label: 'Beschikbare tijdslots' },
  { kleur: 'blauw', labelKey: 'matrix.kleur.blauw', label: 'Medewerker-afspraken' },
  { kleur: 'goud', labelKey: 'matrix.kleur.goud', label: 'Corporate B2B-overleg' },
  { kleur: 'violet', labelKey: 'matrix.kleur.violet', label: 'Intervisie' },
  { kleur: 'terracotta', labelKey: 'matrix.kleur.terracotta', label: 'Opleidingen (Academie)' },
  { kleur: 'mos', labelKey: 'matrix.kleur.mos', label: 'Events & netwerk' },
  { kleur: 'zand', labelKey: 'matrix.kleur.zand', label: 'Vakantie & afwezigheid' },
  { kleur: 'paars', labelKey: 'matrix.kleur.paars', label: 'Privé' },
  { kleur: 'reistijd', labelKey: 'matrix.kleur.reistijd', label: 'Reistijd' },
];
